import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatAnchor, MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ConfigService } from '../../../services/config/config.service';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';

@Component({
	selector: 'vex-redirect-dialog',
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, TranslocoDirective, MatButton, MatIcon, MatAnchor, CdkDrag, CdkDragHandle, MatIconButton],
	templateUrl: './redirect-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './redirect-dialog.component.scss',
})
export class RedirectDialogComponent {
	readonly dialogRef = inject<MatDialogRef<RedirectDialogComponent>>(MatDialogRef);
	readonly configService = inject(ConfigService);

	araAppUrl: string;

	constructor() {
		this.araAppUrl = this.configService.getAraAppUrl();
	}
}
